import LinkedAccountsTemplate from '@/features/agent/linked_accounts/templates/LinkedAccountsTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/linked_accounts/shared')({
  component: LinkedAccountsShared,
});

function LinkedAccountsShared() {
  return <LinkedAccountsTemplate serviceType="database" />;
}
